module.exports = __webpack_public_path__ + "img/17.0fd3060f.png";